import UtmTracker from 'utils/utm_tracker'
import OrganicFlag from 'utils/organic_flag'

class LeadMedium {
  static getName () {
    const utmMedium = UtmTracker.getUtmMedium()
    if (utmMedium) {
      return utmMedium
    }

    const isOrganic = OrganicFlag.isOrganic()
    if (isOrganic) {
      return 'organic'
    }

    return 'direct'
  }
}

export default LeadMedium
